<mat-icon
  class="icon"
  fontSet="material-symbols-outlined"
  >{{ icon() }}</mat-icon
>
@if (label(); as label) {
  <span class="label">{{ label }}</span>
}
@if (isDropdown()) {
  <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
}
